export const calculation = {
  meta: {
    number: "123456",
    date: "29.10.2021",
    repairer: "Rumble Zoetermeer",
    address: "Slotenmakerstraat 20, 2672GD Naaldwijk",
    system: "Audatex",
  },
  vehicle: {
    brand: "Rumble",
    model: "Automotive (2021) / GT",
    typeCode: "06 B1 08",
    license: "RU-MB-00",
    chassis: "niet ingegeven",
    firstRegistration: "01.11.2018",
    lastRegistration: "01.11.2018",
    mileage: "999999 KM",
  },
  parts: [
    {
      code: "0329",
      desc: "Geleiding L bumper V",
      partNo: "20210 807 049 A",
      qty: 1,
      price: 8.86,
    },
    {
      code: "0561",
      desc: "Koplamp L CPL",
      partNo: "20211 941 005 E",
      qty: 1,
      price: 275.94,
    },
    {
      code: "0741",
      desc: "Spatscherm L",
      partNo: "20210 821 105 A",
      qty: 1,
      price: 223.06,
    },
    {
      code: "0791",
      desc: "Moer V L",
      partNo: "N 908 173 02",
      qty: 2,
      price: 2.68,
    },
    {
      code: "0811",
      desc: "Embleem Sp-sch V L",
      partNo: "20210 853 688 R",
      qty: 1,
      price: 41.65,
    },
    {
      code: "0841",
      desc: "Wielkuipbekl V L A",
      partNo: "20210 805 969 P",
      qty: 1,
      price: 53.97,
    },
  ],
  labor: {
    total: 487.68,
    breakdown: [
      { op: "Body Work & Alignment", hours: 7, rate: 85, amount: 595 },
      { op: "Paint & Refinishing", hours: 5, rate: 85, amount: 425 },
    ],
  },
  paint: [
    { op: "Arbeidsloon", amount: 443.46 },
    { op: "Materiaalkosten", amount: 172.62 },
  ],
  additional: [
    { label: "Anti-roestbehandeling", price: 11.35 },
    { label: "Uitlijnen", price: 70.0 },
  ],
  environmental: 27.83,
  totals: {
    parts: 618.28,
    labor: 487.68,
    additional: 81.35,
    paint: 616.08,
    exclVat: 1831.22,
    vat: 384.56,
    inclVat: 2215.78,
  },
};
